function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.135,11.139c3.036,0,5.5-2.463,5.5-5.5V5.5c0-3.037-2.464-5.5-5.5-5.5c-3.038,0-5.5,2.463-5.5,5.5v0.139 C10.635,8.676,13.097,11.139,16.135,11.139"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.768,70.088h-9.134V22.28c0-1.933-1.566-3.5-3.5-3.5H7.688c-1.934,0-3.5,1.567-3.5,3.5s1.566,3.5,3.5,3.5 h4.946v44.308H3.5c-1.932,0-3.5,1.567-3.5,3.5s1.568,3.5,3.5,3.5h25.268c1.934,0,3.5-1.567,3.5-3.5S30.701,70.088,28.768,70.088"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 34,
    height: 78,
    viewBox: "-0.772 -0.479 34 78",
    enableBackground: "new -0.772 -0.479 34 78",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.89a9aa51.svg";
export { ForwardRef as ReactComponent };